import { render, staticRenderFns } from "./CoursewareBlockInfo.vue?vue&type=template&id=56d0c729&"
import script from "./CoursewareBlockInfo.vue?vue&type=script&lang=js&"
export * from "./CoursewareBlockInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports